export const queryConstants = {
    GET_QUERY_REQUEST: 'GET_QUERY_REQUEST',
    GET_QUERY_SUCCESS: 'GET_QUERY_SUCCESS',
    GET_QUERY_FAILURE: 'GET_QUERY_FAILURE',

    GET_ACTIVE_QUERY_REQUEST: 'GET_ACTIVE_QUERY_REQUEST',
    GET_ACTIVE_QUERY_SUCCESS: 'GET_ACTIVE_QUERY_SUCCESS',
    GET_ACTIVE_QUERY_FAILURE: 'GET_ACTIVE_QUERY_FAILURE',

    GET_INACTIVE_QUERY_REQUEST: 'GET_INACTIVE_QUERY_REQUEST',
    GET_INACTIVE_QUERY_SUCCESS: 'GET_INACTIVE_QUERY_SUCCESS',
    GET_INACTIVE_QUERY_FAILURE: 'GET_INACTIVE_QUERY_FAILURE',

    PUT_QUERY_REQUEST: 'PUT_QUERY_REQUEST',
    PUT_QUERY_SUCCESS: 'PUT_QUERY_SUCCESS',
    PUT_QUERY_FAILURE: 'PUT_QUERY_FAILURE',

		POST_QUERY_REQUEST: 'POST_QUERY_REQUEST',
    POST_QUERY_SUCCESS: 'POST_QUERY_SUCCESS',
    POST_QUERY_FAILURE: 'POST_QUERY_FAILURE',
 
 		DELETE_QUERY_REQUEST: 'DELETE_QUERY_REQUEST',
    DELETE_QUERY_SUCCESS: 'DELETE_QUERY_SUCCESS',
    DELETE_QUERY_FAILURE: 'DELETE_QUERY_FAILURE'
};



// WEBPACK FOOTER //
// ./src/_constants/queries.js